import styled from "styled-components";
const WheelDiv = styled.div`
  overflow-y: auto;
  & > ul {
    position: relative;
    margin: 0;
    display: inline-block;
    list-style: none;
    overflow-y: scroll;
    will-change: transform;
    overflow-x: hidden;
    text-align: center;
    padding: 0 5px;
    height: 150px;
    background-color: #fff;
    box-shadow: 1px 3px 10px #fff inset;
    -ms-overflow-style: none;
    scrollbar-width: none;

    & > li {
      align-items: center;
      width: 100%;
      background-image: none;
      padding: 0;
    }
    & > li[aria-selected="true"] {
      background-color: #eeeeef;
    }
    & > li > span {
      display: none;
    }
    & > li > p {
      text-align: center;
      margin: 0 5px;
      width: 100%;
      padding: 0;
    }
    &::-webkit-scrollbar {
      display: none;
    }
    &:focus {
      outline: none;
    }
  }
`;
const customCalendarStyles = {
  closeButton: {
    position: "absolute",
    top: "10px",
    right: "10px",
    zIndex: "20",
    outline: "none",
    border: "none",
    width: "30px",
  },
  modal: {
    position: "fixed",
    padding: 0,
    bottom: 0,
    width: "100%",
    maxWidth: "100%",
    maxHeight: "300px",
    overflowY: "scroll",
    height: "100%",
  },
  overlay: {
    padding: "0",
    height: "100vh",
  },
};

const customCalendarClassNames = {
  closeButton: "close-button-modal",
  modal: "date-time-picker-modal",
  overlay: "overlay-modal",
};

const WrapperStyles = styled.div`
  padding-top: 10px;
  ul > li[aria-selected="true"] {
    background-color: #fff !important;
  }
  ul > li {
    min-height: 30px !important;
  }
  .ms-select-line {
    height: 30px;
    width: 90%;
    position: absolute;
    top: 60px;
    pointer-events: none;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-top: 1px solid #dbdbdb;
    border-bottom: 1px solid #dbdbdb;
    left: 50%;
    transform: translate(-50%);
  }
  .ms-shadow-mask {
    position: absolute;
    top: 0;
    width: 100%;
    height: 150px;
    background: linear-gradient(
      to bottom,
      #fffffff5,
      #ffffffcc 25%,
      #ffffff00 49%,
      #ffffff00 51%,
      #ffffffcc 75%,
      #fffffff5
    );
    opacity: 0.9;
    pointer-events: none;
  }
`;
export {
  WheelDiv,
  customCalendarStyles,
  WrapperStyles,
  customCalendarClassNames,
};
